<template lang="pug">
  header.main-header
    .container
      figure
        a(href='https://axisproto.com/' target='_self')
          img(:src='logo')
      nav.action-nav
        button.button(v-if='isAuthenticated' @click='logout') {{ $t('logout') }}
        button.button.language(@click="goToPage($i18n.locale === 'en' ? 'fr' : 'en')") {{ $i18n.locale === 'fr' ? 'EN' : 'FR' }}
</template>

<script>
import { mapGetters } from 'vuex'
import AxisLogo from '@/assets/images/logo-axis-dark.png'

export default {
  data: () => ({
    path: window.location.pathname.substr(4)
  }),
  computed: {
    logo: () => AxisLogo,
    ...mapGetters('auth', ['isAuthenticated'])
  },
  methods: {
    goToPage (lang) {
      const path = window.location.pathname.substr(4)
      const href = `/${lang}/${path}`
      this.$router.push(href)
    },
    async logout () {
      await this.$store.dispatch('auth/logout')
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/scss/abstract/variables.scss';

  .action-nav {
    color: #fff;

    @media only screen and (max-width: $mobile) {
      text-align: center;
      display: inline-block;
      vertical-align: middle;
      margin: 1em;
    }

    .button {
      display: inline-block;
      border: 2px solid $blue;
      color: inherit;
      padding: 1em 1.2em;
      border-radius: 0;
      background: $blue;
      font-size: 0.8em;

      &:not(.language) {
        border: 0;
        background: #fff;
        color: $blue;

        &:hover {
          color: $blue;
          background-color: #fff;
        }
      }

      &:hover {
        color: #fff;
        background-color: $blue;
      }
    }
  }
  header {
    padding: 1em 0;
    background-color: #fff;
  }
  .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1em;

    @media only screen and (max-width: $mobile) {
      display:block;
      text-align:center;
    }
  }
  figure {
    margin: 0;

    @media only screen and (max-width: $mobile) {
      text-align: center;
      display: inline-block;
      vertical-align: middle;
      margin: 1em;
    }
  }
</style>
